module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter01"
    }
  }), _vm._v("Gasoline Prices"), _c('br'), _vm._v("Expected to Climb Higher")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASHINGTON")]), _vm._v("—There’s pump shock at every corner gas station, with prices well over $7 a gallon—and the government says you’d better get used to it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Energy Department projects high gasoline prices at least through next year as producers struggle to keep up with demand, which has not slackened appreciably despite rising prices.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Crude oil prices climbed to an all-time high of $112 per barrel yesterday, triggering a 634-point drop in the Dow-Jones Industrial average on the New York Stock Exchange.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“We can expect to see gasoline prices soar as high as nine or ten dollars a gallon this summer,” said James Dykes, chairman of the Federal Reserve Board. “Gas prices have nowhere to go but up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Energy Department officials blamed the climbing oil prices on the growing demand for petroleum by China and India, two of the fastest-growing economies in the world, coupled with the fact that global oil production has peaked and is unlikely to increase.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“There hasn’t been a major new oil field discovered in well over a decade,” said Roberta Groves, head of Gould Energy Corporation’s explorations division. “With global oil production flat and global demand increasing steadily, oil prices will continue to climb for the foreseeable future.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—"), _c('em', [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INANCIAL")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EWS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3574bc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 90
// module chunks = 0